// extracted by mini-css-extract-plugin
module.exports = {"policyTitle":"ClientExpandedPolicy_policyTitle__a9_wY"};